import { gql } from '@apollo/client'

/**
 * `refreshToken` — refresca el access token usando la cookie httpOnly de
 * refresh (set por el gateway en `Domain=.tecopos.com`).
 *
 * Importante: esta mutation debe enviarse **sin** `Authorization` header
 * (porque el access token actual podría estar expirado). El errorLink garantiza
 * eso al ponerla en una operación marcada con `context: { skipAuth: true }`.
 */
export const REFRESH_TOKEN = gql`
  mutation refreshToken {
    refreshToken {
      accessToken
    }
  }
`

/**
 * `logout` — invalida la sesión en el backend (limpia la cookie de refresh).
 * El frontend además debe limpiar el access token en memoria y el cache de Apollo.
 */
export const LOGOUT = gql`
  mutation logout {
    logout
  }
`

/**
 * `signIn` — login con email + contraseña. Devuelve el accessToken; el gateway
 * también setea la cookie httpOnly de refresh en `Domain=.tecopos.com`.
 */
export const SIGN_IN = gql`
  mutation signIn($email: String!, $password: String!) {
    signIn(data: { email: $email, password: $password }) {
      accessToken
    }
  }
`

/**
 * `portalRegister` — primer paso del wizard de registro. Crea el usuario en
 * Identity (sin rol de portal — el onboarding es abierto) y dispara el envío
 * del código de verificación por email.
 */
export const PORTAL_REGISTER = gql`
  mutation portalRegister(
    $email: String!
    $phone: String!
    $password: String!
    $firstName: String!
    $lastName: String!
  ) {
    portalRegister(
      input: {
        email: $email
        phone: $phone
        password: $password
        firstName: $firstName
        lastName: $lastName
      }
    )
  }
`

/**
 * `portalVerifyCode` — valida el código de 6 dígitos enviado por email.
 * Devuelve el accessToken (el gateway también setea la cookie de refresh).
 */
export const PORTAL_VERIFY_CODE = gql`
  mutation portalVerifyCode($email: String!, $code: String!) {
    portalVerifyCode(input: { email: $email, code: $code }) {
      accessToken
    }
  }
`

/**
 * `portalResendCode` — reenvía el código de verificación al email.
 */
export const PORTAL_RESEND_CODE = gql`
  mutation portalResendCode($email: String!) {
    portalResendCode(email: $email)
  }
`
